var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75895 8.46241C2.41581 8.46241 0.518066 6.56466 0.518066 4.24089C0.518066 1.91711 2.41581 0 4.75895 0C7.10209 0 8.99984 1.89775 8.99984 4.24089C8.99984 6.58402 7.08272 8.46241 4.75895 8.46241ZM4.75895 1.16189C3.05485 1.16189 1.67995 2.53679 1.67995 4.24089C1.67995 5.94499 3.05485 7.31988 4.75895 7.31988C6.44369 7.31988 7.83795 5.94499 7.83795 4.24089C7.83795 2.53679 6.44369 1.16189 4.75895 1.16189Z",
    fill: "#F65C8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75868 13.999C4.42948 13.999 4.17773 13.7473 4.17773 13.4181V7.87977C4.17773 7.55057 4.42948 7.29883 4.75868 7.29883C5.08788 7.29883 5.33962 7.55057 5.33962 7.87977V13.4181C5.33962 13.7473 5.06851 13.999 4.75868 13.999Z",
    fill: "#F65C8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42421 12.4509H3.07411C2.74491 12.4509 2.49316 12.1992 2.49316 11.87C2.49316 11.5408 2.74491 11.2891 3.07411 11.2891H6.42421C6.75341 11.2891 7.00516 11.5408 7.00516 11.87C7.00516 12.1798 6.75341 12.4509 6.42421 12.4509Z",
    fill: "#F65C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.81849458.svg";
export { ForwardRef as ReactComponent };